<template>
  <el-container>
    <el-main>
      <div class="nesc_e3s1_top">
        <div class="nesc_cont950 nesc_e3s1t_cont">
          <div class="nesc_e3s1_hd">
            <h1 class="nesc_e3s1_title">{{ title }}</h1>
            <div class="nesc_e3s1_date">{{ $route.params.time.replace(/-/g, '/') }}</div>
          </div>
        </div>
      </div>

      <div class="nesc_e3s1_bot">
        <div class="nesc_cont950 nesc_e3s1b_cont">
          <!-- 编辑器 -->
          <div class="nesc_e3s1b_txtbox yxedr_active">
            <iframe @load="adjustIframe" frameborder="0" id="otherIframe" style="width: 100%;min-height: calc(80vh - 200px);" :src="url"></iframe>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'NewsDetail',
  data: () => {
    return {
      title: '',
      content: '',
      url: ''
    }
  },

  mounted() {
    window.scrollTo(0, 0)
    this.getData()
  },

  updated() {
  },

  methods: {
    getData() {
      let url = "/FrameContent/NewsInfo?id=" + this.$route.params.id
      this.url = url
      this.$http.post(this.isDevelop ? '/NewsInfo' : '/api/NewsService/NewsInfo', { id: this.$route.params.id }).then(
        (responseNews) => {
          if (responseNews.statusText == 'OK' && responseNews.data) {
            this.title = responseNews.data.Data.Title
          }
        }
      )
    },

    adjustIframe() {
      var ifm = document.getElementById("otherIframe");
      let doc = (ifm.contentWindow || ifm.contentDocument.parentWindow).document;
      if (doc != undefined && doc.body != undefined) {
        let height = doc.body.scrollHeight;
        ifm.height = '0' // 先改为0，避免内容变小了，而高度还处于撑开的高度
        ifm.height = height + 'px';
      }
    }
  },

}
</script>

<style scoped lang="scss">
.yxedr_active >>> p {
  font-size: 18px !important;
  line-height: 1.75 !important;;
  color: #111 !important;;
  letter-spacing: 1px;
}
.yxedr_active >>> img, .yxedr_active >>> video {
  height: auto !important;
}
.yxedr_active >>> img, .yxedr_active >>> video , .yxedr_active >>> audio {
  max-width: 100% !important;
}

@media screen and (max-width: 767px) {
  .yxedr_active >>> p {
    font-size: 14px !important;
  }
}
</style>

<style scoped lang="scss">
.el-container {
  background: rgb(247,248,250) !important;
}

.nesc_e3s1_top {
  padding: 90px 0 52px;
  background: #f7f8fa;
}
.nesc_e3s1t_cont {
  position: relative;
}
.nesc_cont950 {
  width: 950px;
  margin: 0 auto;
}

/*标题*/
.nesc_e3s1_title {
  font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  font-size: 36px;
  line-height: 2;
  font-weight: bold;
  color: #333333;
  margin-bottom: 48px;
}

/*时间*/
.nesc_e3s1_date {
  font-size: 18px;
  font-weight: bold;
  font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  color: #666666;
}

/*编辑器-vhtml?*/
.nesc_e3s1_bot {
  background: #ffffff;
  padding-bottom: 80px;
}
.nesc_e3s1_bot {
  padding: 60px 0 100px;
}
.nesc_cont950 {
  width: 950px;
  margin: 0 auto;
}
.nesc_e3s1b_txtbox {
  padding: 0 85px 85px;
}

@media screen and (max-width: 1680px) {
  .nesc_e3s1_title {
    font-size: 34px;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_e3s1_title {
    font-size: 32px;
  }
}

@media screen and (max-width: 991px) {
  .nesc_e3s1_top {
    padding: 50px 0 35px;
  }
  .nesc_cont950 {
    width: 100%;
    padding: 0 30px;
  }
  .nesc_e3s1_title {
    font-size: 22px;
    line-height: 1.5;
    margin-bottom: 20px;
  }
  .nesc_e3s1_date {
    font-size: 12px;
  }
  .nesc_e3s1_bot {
    padding: 30px 0;
  }
  .nesc_cont950 {
    width: 100%;
    padding: 0 30px;
  }
  .nesc_e3s1b_txtbox {
    padding: 0 0 30px;
  }
  .nesc_e3s1b_txtbox p {
    font-size: 16px;
    line-height: 1.75;
  }
}

@media screen and (max-width: 767px) {
  .nesc_e3s1_top {
    padding: 35px 0;
  }
  .nesc_e3s1_bot {
    padding-bottom: 30px;
  }
}

</style>
